import React, { useEffect, Fragment, useState, useCallback } from "react";
import { SimpleGrid, Container, Heading, Stack, StackDivider, Box, UnorderedList, Text, Image } from '@chakra-ui/react';
import { useWeb3React } from "@web3-react/core";
import classNames from "classnames";

const Marketplace = () => {

    const {
        library,
        chainId,
        account,
        activate,
        deactivate,
        active
    } = useWeb3React();

    /*
    const [games, setgames] = useState([
        {
            NFTnum: 1,
            NFTname: "NFT 1",
            NFTimage: require("../assets/images/sample_nfts/NFT1.png"),
            NFTprice: "1 ETH"
        },
        {
            NFTnum: 2,
            NFTname: "NFT 2",
            NFTimage: require("../assets/images/sample_nfts/NFT2.png"),
            NFTprice: "2 ETH"
        },
        {
            NFTnum: 3,
            NFTname: "NFT 3",
            NFTimage: require("../assets/images/sample_nfts/NFT3.png"),
            NFTprice: "3 ETH"
        },
        {
            NFTnum: 4,
            NFTname: "NFT 4",
            NFTimage: require("../assets/images/sample_nfts/NFT4.png"),
            NFTprice: "4 ETH"
        }
    ]);
    */

    const [games, setGames] = useState([
        {
            gameNum: 1,
            gameName: "Classic Snake Game",
            gameImage: require("../assets/images/games/SnakeGame.png"),
            gamePrice: "0.1 ETH"
        },
        {
            gameNum: 2,
            gameName: "Hoop Jump Game",
            gameImage: require("../assets/images/games/HoopJumpGame.png"),
            gamePrice: "0.1 ETH"
        },
    ]);

    const [q, setQ] = useState("");
    const [searchParams] = useState(["gameNum", "gameName"]);
    const [filterParam, setFilterParam] = useState(["All"]);

    function search(games) {
        return games.filter((item) => {
            if (item.NFTnum == filterParam) {
                return searchParams.some((newItem) => {
                    return (
                        item[newItem]
                            .toString()
                            .toLowerCase()
                            .indexOf(q.toLowerCase()) > -1
                    );
                });
            } else if (filterParam == "All") {
                return searchParams.some((newItem) => {
                    return (
                        item[newItem]
                            .toString()
                            .toLowerCase()
                            .indexOf(q.toLowerCase()) > -1
                    );
                });
            }
        });
    }
    
    return (
        <section className={classNames("section", "center-content", "marketplace-section")}>
            <div className="marketplace-container">
                <h1>Marketplace</h1>
                <div className="marketplace-area">
                    <div className="search-wrapper">
                        <label htmlFor="search-form">
                            <input
                                type="search"
                                name="search-form"
                                id="search-form"
                                className="search-input"
                                placeholder="Search for..."
                                value={q}
                                /*
                                // set the value of our useState q
                                //  anytime the user types in the search box
                                */
                                onChange={(e) => setQ(e.target.value)}
                            />
                            <span className="sr-only">Search games here</span>
                        </label>
                        <div className="select">
                            <select
                                onChange={(e) => {
                                    setFilterParam(e.target.value);
                                }}
                                className="custom-select"
                                aria-label="Filter Game"
                            >
                                <option value="All">Filter By Game</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </select>
                            <span className="focus"></span>
                        </div>
                    </div>
                </div>
            {/*
            <div className="NFT-section">
                <SimpleGrid columns={4} minChildWidth='300px' m={5}>
                    {search(games).map((item) => (
                        <Box bg="white" maxWidth="300px" _hover={{transform: 'scale(1.1)'}}>
                            <Image src={item.NFTimage} alt=""/>
                            <Box bg="white">
                                <Stack divider={<StackDivider />} spacing='4'>
                                    <Box bg="white" mt={5} mb={0}>
                                        <Text textAlign="left" m={2}>
                                            {item.NFTname}<br/>
                                            Price: {item.NFTprice}
                                        </Text>
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>
                    ))}
                </SimpleGrid>
            </div>
            */}
            
            {/*
                <div className="sidebar">
                    <div className="items">
                        <h3>Categories</h3>
                        <br/>
                        <div>
                            <label for="allCategories">All categories</label>
                            <input
                            type="radio"
                            name="price"
                            id="allCategories"
                            />
                        </div>
                        <div>
                            <label for="action">Action</label>
                            <input
                            type="radio"
                            name="action"
                            id="action"
                            />
                        </div>
                        <div>
                            <label for="adventure">Adventure</label>
                            <input
                            type="radio"
                            name="adventure"
                            id="adventure"  
                            />
                        </div>
                        <div>
                            <label for="puzzle">Puzzle</label>
                            <input
                            type="radio"
                            name="puzzle"
                            id="puzzle"
                            />
                        </div>
                        <div>
                            <label for="racing">Racing</label>
                            <input
                            type="radio"
                            name="racing"
                            id="racing"
                            />
                        </div>
                        <div>
                            <label for="rpg">RPG</label>
                            <input
                            type="radio"
                            name="rpg"
                            id="rpg"
                            />
                        </div>
                        <div>
                            <label for="shooter">Shooter</label>
                            <input
                            type="radio"
                            name="Shooter"
                            id="Shooter"
                            />
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <div className="items">
                        <h3>Prices</h3>
                        <div>
                            <label for="allPrices">All prices</label>
                            <input
                            type="radio"
                            name="price"
                            id="allPrices"
                            />
                        </div>
                        <div>
                            <label for="priceRange">Price range</label>
                            <input
                            type="radio"
                            name="price"
                            id="priceRange"
                            />
                        </div>
                    </div>
                </div>
        */}
                <div className="games-section">
                    <SimpleGrid columns={4} minChildWidth='300px' m={5}>
                        {search(games).map((item) => (
                            <Box bg="white" maxWidth="300px" _hover={{transform: 'scale(1.1)'}}>
                                <Image src={item.gameImage} alt=""/>
                                <Box bg="white">
                                    <Stack divider={<StackDivider />} spacing='4'>
                                        <Box bg="white" mt={5} mb={0}>
                                            <Text textAlign="left" m={2}>
                                                {item.gameName}<br/>
                                                Price: {item.gamePrice}
                                            </Text>
                                        </Box>
                                    </Stack>
                                </Box>
                            </Box>
                        ))}
                    </SimpleGrid>
                </div>
            </div>
            
        </section>
    )  
}

export default Marketplace;